import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import logoLight from 'views/pages/Login/images/kiwi-full-logo.svg'
import { Eye, EyeOff } from 'react-feather'

import AxiosInstance from 'utils/AxiosInstance'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLock,
  faCheckCircle,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import { updateUserLastActivity, fetchCurrentUser } from 'store/user/actions'
import { useDispatch } from 'react-redux'

function ForceChangePassword() {
  const dispatch = useDispatch()
  const history = useHistory()

  const theme = useSelector((state) => state.themeConfig?.theme || {})
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess(false)
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.')
      return
    }
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }
    setLoading(true)
    try {
      await AxiosInstance.post('/users/self/change-password', {
        firstTime: true,
        newPassword,
        confirmPassword,
      })
      setSuccess(true)
      setTimeout(() => {
        history.push('/')
      }, 1200)

      dispatch(updateUserLastActivity())
      dispatch(fetchCurrentUser())
    } catch (err) {
      if (err?.response?.data?.error) {
        setError(err.response.data.error)
      } else {
        setError('Failed to update password. Please try again.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className='d-flex align-items-center justify-content-center'
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 40,
          left: 0,
          right: 0,
          zIndex: 10,
          textAlign: 'center',
        }}
      >
        <img
          src={
            theme.loginLogo && theme.loginLogo.url
              ? theme.loginLogo.url
              : logoLight
          }
          alt='Client Logo'
          style={{ maxHeight: 60, maxWidth: 220 }}
        />
      </div>
      <div
        className='card shadow-lg p-4'
        style={{
          maxWidth: 400,
          width: '100%',
          borderRadius: 16,
          marginTop: 80,
        }}
      >
        <div className='text-center mb-4'>
          <FontAwesomeIcon
            icon={faLock}
            size='2x'
            className='text-primary mb-2'
          />
          <h3 style={{ fontWeight: 700, color: '#32325d' }}>
            Change Your Password
          </h3>
          <p className='text-muted' style={{ fontSize: 15 }}>
            For security, you must set a new password before continuing.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='form-group mb-3' style={{ position: 'relative' }}>
            <label htmlFor='newPassword' style={{ fontWeight: 600 }}>
              New Password
            </label>
            <input
              type={showNewPassword ? 'text' : 'password'}
              className='form-control'
              id='newPassword'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder='Enter new password'
              minLength={8}
              required
              style={{ borderRadius: 8 }}
            />
            <span
              style={{
                position: 'absolute',
                right: 16,
                top: 38,
                cursor: 'pointer',
              }}
              onClick={() => setShowNewPassword((v) => !v)}
            >
              {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>
          <div className='form-group mb-3' style={{ position: 'relative' }}>
            <label htmlFor='confirmPassword' style={{ fontWeight: 600 }}>
              Confirm Password
            </label>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              className='form-control'
              id='confirmPassword'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder='Confirm new password'
              minLength={8}
              required
              style={{ borderRadius: 8 }}
            />
            <span
              style={{
                position: 'absolute',
                right: 16,
                top: 38,
                cursor: 'pointer',
              }}
              onClick={() => setShowConfirmPassword((v) => !v)}
            >
              {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>
          {error && (
            <div
              className='alert alert-danger d-flex align-items-center py-2 mb-3'
              style={{ borderRadius: 8 }}
            >
              <FontAwesomeIcon icon={faExclamationTriangle} className='mr-2' />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div
              className='alert alert-success d-flex align-items-center py-2 mb-3'
              style={{ borderRadius: 8 }}
            >
              <FontAwesomeIcon icon={faCheckCircle} className='mr-2' />
              <span>Password updated successfully!</span>
            </div>
          )}
          <button
            type='submit'
            className='btn btn-primary btn-block'
            style={{ fontWeight: 600, fontSize: 16, borderRadius: 8 }}
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default ForceChangePassword
